export const locale = {
    lang: 'en',
    data: {
        'Buttons': {
            'Plan': 'Plan',
            'Nonworkinghours': 'Nonworking',
        },
    }
}